import { defineStore } from 'pinia';
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

const initialAborescence = {
    account: {
        id: 'account',
        label: 'Informations personnelles',
        color: 'jinius-green',
        restricted: true,
        rubriques: {
            account: {
                id: 'account',
                sous_rubriques: {
                    informations: {
                        id: 'informations',
                        label: 'Informations',
                        icon: 'IconParticipants'
                    },
                    preferences: {
                        id: 'preferences',
                        label: 'Préférences',
                        icon: 'IconFlagParcours'
                    }
                }
            }
        }
    },
    gestion: {
        id: 'gestion',
        label: 'Gestion',
        rubriques: {
            gestion: {
                id: 'gestion',
                label: 'Gestion & Suivi',
                reduced_label: 'Gestion',
                sous_rubriques: {
                    accueil: {
                        id: 'accueil',
                        label: 'Tableau de bord',
                        icon: 'IconDashboard'
                    },
                    inscriptions: {
                        id: 'inscriptions',
                        label: 'Inscriptions',
                        icon: 'IconFormations'
                    },
                    sessions: {
                        id: 'sessions',
                        label: 'Sessions intra',
                        icon: 'IconFlagParcours',
                        menuHidden: true
                    },
                    commandes: {
                        id: 'commandes',
                        label: 'Commandes',
                        icon: 'IconCommandes'
                    },
                    factures: {
                        id: 'factures',
                        label: 'Factures',
                        icon: 'IconFactures'
                    },
                    contrats: {
                        id: 'contrats',
                        label: 'Contrats Form.',
                        headerLabel: 'Contrats Formateurs',
                        icon: 'IconTestPositionnement',
                        menuHidden: true
                    },
                    'inscriptions-session': {
                        id: 'inscriptions-session',
                        label: 'Inscriptions',
                        icon: 'IconFormations',
                        hideScope: true,
                        menuHidden: true
                    },
                    'inscriptions-cursus': {
                        id: 'inscriptions-cursus',
                        label: 'Inscriptions',
                        icon: 'IconFormations',
                        hideScope: true,
                        menuHidden: true
                    },
                    'inscriptions-elearning': {
                        id: 'inscriptions-elearning',
                        label: 'Inscriptions',
                        icon: 'IconFormations',
                        hideScope: true,
                        menuHidden: true
                    },
                    'sessions-details': {
                        id: 'sessions-details',
                        label: 'Sessions intra',
                        icon: 'IconFlagParcours',
                        hideScope: true,
                        menuHidden: true
                    },
                    'sessions-cursus-elearning-details': {
                        id: 'sessions-cursus-elearning-details',
                        label: 'Sessions intra',
                        icon: 'IconFlagParcours',
                        hideScope: true,
                        menuHidden: true
                    },
                    'sessions-cursus-session-details': {
                        id: 'sessions-cursus-session-details',
                        label: 'Sessions intra',
                        icon: 'IconFlagParcours',
                        hideScope: true,
                        menuHidden: true
                    },
                    'commandes-details': {
                        id: 'commandes-details',
                        label: 'Commandes',
                        icon: 'IconCommandes',
                        hideScope: true,
                        menuHidden: true
                    }
                }
            },
            administration: {
                id: 'administration',
                label: 'Administration',
                reduced_label: 'Admin',
                need_admin_rights: true,
                sous_rubriques: {
                    annuaire: {
                        id: 'annuaire',
                        label: 'Annuaire',
                        icon: 'IconParticipants',
                        admin: true
                    },
                    interlocuteurs: {
                        id: 'interlocuteurs',
                        label: 'Interlocuteurs',
                        icon: 'IconInterlocuteurs',
                        admin: true
                    },
                    etablissements: {
                        id: 'etablissements',
                        label: 'Etablissements',
                        icon: 'IconEstablishments',
                        admin: true
                    },
                    'etablissements-details': {
                        id: 'etablissements-details',
                        label: 'Etablissements',
                        icon: 'IconEstablishments',
                        hideScope: true,
                        menuHidden: true,
                        admin: true
                    },
                    satisfaction: {
                        id: 'satisfaction',
                        label: 'Enquêtes client',
                        icon: 'IconTestValidation',
                        admin: true
                    }
                }
            }
        },
        connexionPriority: 3,
        restricted: true,
        color: 'refonte_blue-800'
    },
    inscription: {
        id: 'inscription',
        label: 'Participant',
        color: 'jinius-red',
        connexionPriority: 12,
        restricted: true,
        rubriques: {
            gestion: {
                id: 'formation',
                label: '',
                reduced_label: '',
                sous_rubriques: {
                    accueil: {
                        id: 'accueil',
                        label: 'Tableau de bord',
                        icon: 'IconDashboard'
                    },
                    formations: {
                        id: 'formations',
                        label: 'Mes formations',
                        icon: 'IconFormations'
                    },
                    'formations-details': {
                        id: 'formations-details',
                        label: 'Mes formations',
                        icon: 'IconFormations',
                        hideScope: true,
                        menuHidden: true
                    },
                    'formations-cursus-details': {
                        id: 'formations-cursus-details',
                        label: 'Mes formations',
                        icon: 'IconFormations',
                        hideScope: true,
                        menuHidden: true
                    },
                    'formations-details-elearning': {
                        id: 'formations-details-elearning',
                        label: 'Mes formations',
                        icon: 'IconFormations',
                        hideScope: true,
                        menuHidden: true
                    }
                }
            }
        }
    },
    formateur: {
        id: 'formateur',
        label: 'Formateur',
        color: 'jinius-green',
        connexionPriority: 1,
        restricted: true,
        rubriques: {
            formateur: {
                id: 'formateur',
                label: '',
                reduced_label: '',
                sous_rubriques: {
                    sessions: {
                        id: 'sessions',
                        label: 'Mes sessions',
                        icon: 'IconFormations'
                    },
                    'session-details': {
                        id: 'session-details',
                        label: 'Mes sessions',
                        icon: 'IconFormations',
                        hideScope: true,
                        menuHidden: true
                    },
                    agenda: {
                        id: 'agenda',
                        label: 'Agenda',
                        icon: 'IconFlagParcours'
                    },
                    appreciations: {
                        id: 'appreciations',
                        label: 'Appréciations',
                        icon: 'IconTestValidation'
                    },
                    navettes: {
                        id: 'navettes',
                        label: 'Mes candidatures',
                        icon: 'IconInterlocuteurs'
                    },
                    cv: {
                        id: 'cv',
                        label: 'Mon CV',
                        icon: 'IconParticipants'
                    },
                    contrats: {
                        id: 'contrats',
                        label: 'Contrats',
                        icon: 'IconFactures'
                    }
                }
            }
        }
    },
    controleurdestagecac: {
        id: 'controleurdestagecac',
        label: 'Contrôleur de stage CAC',
        color: 'jinius-pink',
        connexionPriority: 4,
        restricted: true,
        rubriques: {
            controleurdestagecac: {
                id: 'controleurdestagecac',
                label: '',
                reduced_label: '',
                sous_rubriques: {
                    stagiaires: {
                        id: 'stagiaires',
                        label: 'Mes stagiaires',
                        icon: 'IconFormations'
                    }
                }
            }
        }
    },
    controleurdestageec: {
        id: 'controleurdestageec',
        label: 'Contrôleur de stage EC',
        color: 'jinius-purple',
        connexionPriority: 4,
        restricted: true,
        rubriques: {
            controleurdestageec: {
                id: 'controleurdestageec',
                label: '',
                reduced_label: '',
                sous_rubriques: {
                    stagiaires: {
                        id: 'stagiaires',
                        label: 'Mes stagiaires',
                        icon: 'IconFormations'
                    }
                }
            }
        }
    },
    maitredestage: {
        id: 'maitredestage',
        label: 'Maître de stage EC',
        color: 'jinius-yellow',
        connexionPriority: 5,
        restricted: true,
        rubriques: {
            maitredestage: {
                id: 'maitredestage',
                label: '',
                reduced_label: '',
                sous_rubriques: {
                    stagiaires: {
                        id: 'stagiaires',
                        label: 'Mes stagiaires',
                        icon: 'IconFormations'
                    }
                }
            }
        }
    },
    stagiaire: {
        id: 'stagiaire',
        label: 'Stagiaire EC',
        color: 'jinius-pink',
        connexionPriority: 10,
        restricted: true,
        rubriques: {
            stagiaire: {
                id: 'stagiaire',
                label: '',
                sous_rubriques: {
                    elearning: {
                        id: 'elearning',
                        label: 'Mes Informations',
                        icon: 'IconParticipants'
                    },
                    sessions: {
                        id: 'sessions',
                        label: 'Mes sessions',
                        icon: 'IconFormations'
                    },
                    'session-details': {
                        id: 'session-details',
                        label: 'Mes sessions',
                        icon: 'IconFormations',
                        hideScope: true,
                        menuHidden: true
                    }
                }
            }
        }
    },
    stagiaireCAC: {
        id: 'stagiaireCAC',
        label: 'Stagiaire CAC',
        color: 'jinius-pink',
        connexionPriority: 10,
        restricted: true,
        rubriques: {
            stagiaireCAC: {
                id: 'stagiaireCAC',
                label: '',
                sous_rubriques: {
                    informations: {
                        id: 'informations',
                        label: 'Mes Informations',
                        icon: 'IconParticipants'
                    },
                    sessions: {
                        id: 'sessions',
                        label: 'Mes sessions',
                        icon: 'IconFormations'
                    },
                    'session-details': {
                        id: 'session-details',
                        label: 'Mes sessions',
                        icon: 'IconFormations',
                        hideScope: true,
                        menuHidden: true
                    },
                    formations: {
                        id: 'formations',
                        label: 'Formations libres',
                        icon: 'IconFormations'
                    }
                }
            }
        }
    }
};
export const useArborescenceStore = defineStore('arborescence', () => {
    const arborescence = ref(initialAborescence);

    const route = useRoute();

    const activeSpaceId = ref(route.params.space_id);
    const activeSubSpaceId = ref(route.params.sub_space_id);
    const subLabel = ref();

    const getFirstSousRubrique = (spaceId) => {
        const firstRubrique = Object.keys(
            arborescence.value[spaceId].rubriques
        )[0];
        return Object.keys(
            arborescence.value[spaceId].rubriques[firstRubrique].sous_rubriques
        )[0];
    };
    const showOrHideAllSousRubriques = (spaceId, hide) => {
        const arbo = arborescence.value?.[spaceId]?.rubriques;
        if (!arbo) return;

        Object.entries(arbo).forEach(([rubriqueKey, rubrique]) => {
            if (!rubrique.sous_rubriques) return;

            Object.keys(rubrique.sous_rubriques).forEach((sousRubriqueId) => {
                setSousRubrique(
                    spaceId,
                    rubriqueKey,
                    sousRubriqueId,
                    'menuHidden',
                    hide
                );
            });
        });
    };

    const getActiveSousRubrique = (spaceId, subSpaceId) => {
        if (subSpaceId && spaceId) {
            const rubriques = Object.keys(arborescence.value[spaceId].rubriques)
                .map(
                    (r) =>
                        arborescence.value[spaceId].rubriques[r].sous_rubriques
                )
                .reduce((acc, cur) => ({ ...acc, ...cur }), {});
            return rubriques[subSpaceId];
        }
        return null;
    };
    const activeRubrique = ref(
        getActiveSousRubrique(activeSpaceId.value, activeSubSpaceId.value)
    );

    watch(
        () => activeSpaceId,
        (newId) => {
            activeRubrique.value = getActiveSousRubrique(
                newId.value,
                activeSubSpaceId.value
            );
        }
    );
    watch(
        () => activeSubSpaceId,
        (newId) => {
            activeRubrique.value = getActiveSousRubrique(
                activeSpaceId,
                newId.value
            );
        }
    );

    function setActiveSpaceId(id) {
        activeSpaceId.value = id;
    }
    function setActiveSubSpaceId(id) {
        activeSubSpaceId.value = id;
        activeRubrique.value = getActiveSousRubrique(activeSpaceId.value, id);
    }
    const setSubLabel = (value) => {
        subLabel.value = value;
    };

    const setSousRubrique = (espace, rubrique, sousRubrique, name, value) => {
        const arboCopy = arborescence.value;
        arboCopy[espace].rubriques[rubrique].sous_rubriques[sousRubrique] = {
            ...arboCopy[espace].rubriques[rubrique].sous_rubriques[
                sousRubrique
            ],
            [name]: value
        };
        arborescence.value = arboCopy;
    };

    const setSpace = (espace, name, value) => {
        arborescence.value = {
            ...arborescence.value,
            [espace]: {
                ...arborescence.value[espace],
                [name]: value
            }
        };
    };

    return {
        setSpace,
        arborescence,
        activeRubrique,
        setActiveSubSpaceId,
        setActiveSpaceId,
        subLabel,
        setSubLabel,
        setSousRubrique,
        getFirstSousRubrique,
        showOrHideAllSousRubriques
    };
});
